/* global axios */
import ApiClient from './ApiClient';

// Creating WhatsApp templates is not part of upstream Chatwoot, which can only
// sync templates that already exist in Meta. These endpoints are ours.
class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // Reads live from Meta rather than the cached channel.message_templates, so a
  // status change (PENDING -> APPROVED) shows up straight away.
  getTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  createTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, { template });
  }

  getPhoneNumbers(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_phone_numbers`);
  }
}

export default new WhatsappTemplatesAPI();
